import React, { useState } from "react";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import styled from "styled-components";
const ImageGallery = ({ images, OrbUrl }) => {
  const [index, changeIndex] = useState(0);
  let imageList = images.toList().toJS();

  OrbUrl && imageList.unshift(OrbUrl);
  const length = imageList.length;

  const isPrevDisabled = index === 0;
  const isNextDisabled = length === 0 || index === length - 1;

  return (
    <>
      <div className="row">
        <div className="col-1 align-self-center text-center">
          <ArrowSpan
            disabled={isPrevDisabled}
            onClick={() => {
              if (!isPrevDisabled) changeIndex(index - 1);
            }}
          >
            <FaLessThan />
          </ArrowSpan>
        </div>
        <div className="col-10">
          {length === 0 ? (
            <NoImagePlaceholder />
          ) : OrbUrl && index === 0 ? (
            <iframe
              id="surroundingFrame"
              title="Orb 360"
              width="96%"
              height="100%"
              frameBorder="0"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              src={imageList[index]}
            ></iframe>
          ) : (
            <StyledImg
              className="img-fluid"
              src={imageList[index]}
              alt=""
            />
          )}
        </div>
        <div className="col-1 align-self-center text-center">
          <ArrowSpan
            disabled={isNextDisabled}
            onClick={() => {
              if (!isNextDisabled) changeIndex(index + 1);
            }}
          >
            <FaGreaterThan />
          </ArrowSpan>
        </div>
      </div>
    </>
  );
};

const NoImagePlaceholder = styled.div`
  height: 100vh;
`;

const StyledImg = styled.img`
  max-height: 99vh;
`;

const ArrowSpan = styled.span`
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;

export default React.memo(ImageGallery);
